import { useMemo } from 'react';

/**
 * Hook for environment-based configuration
 * @returns {object} Environment configuration
 */
export const useEnvironmentConfig = () => {
  const config = useMemo(() => {
    const isDev = process.env.REACT_APP_NODE_ENV === 'dev';
    
    return {
      isDev,
      isProd: !isDev,
      backendUrl: isDev ? 'http://localhost:4242' : process.env.REACT_APP_BACKEND_URL,
      nodeEnv: process.env.REACT_APP_NODE_ENV,
    };
  }, []);

  return config;
};
